export const requisites = {
    ogrn: '1255000088606',
    inn: '5003171243',
    kpp: '500301001',
    okpo: '88889754',
    oktao: '46407000000',
    okfs: '16, Частная собственность',
    oktmo: '46707000001',
    okogu: '4210014',
    okopf: '12300',
    registration_data: '25.09.2025',
    ur_address: '142715, Московская область, г Видное, промзона Северная Промзона, пр-д Проектируемый № 5208, зд. 3/3а, этаж/комната 1/5',
}

export const contacts = {
    sales_department_phone: '79362766420',
    commerce_department_phone: '74952754030',
    logistics_department_phone: '79254754280',
    info_mail: 'info@vtorchermet-1.ru',
    whatsapp: 'https://api.whatsapp.com/send/?phone=79362766420&text&type=phone_number&app_absent=0',
    telegram: 'https://t.me/Vtorchermett1',
    max: 'https://max.ru/u/f9LHodD0cOL6sbuSDVac-qnRDgwCs7oT1Xx1fzpFpQFwc0KEV3sgwoEm8D0',
    yandex_map_link: 'https://yandex.ru/maps/-/CPuhjTN8',
    address: 'Московская область, городской округ Мытищи',
}
